import IconInfoCircle from 'src/presentations/components/atom/icons/InfoCircle';
import { DeviationDto } from 'src/generated/services/TFinancialApi';
import IconCheckCircle from 'src/presentations/components/atom/icons/CheckCircle';
import IconExclamationCircle from 'src/presentations/components/atom/icons/ExclamationCircle';
import { useMemo } from 'react';
import { TabIconWrapper } from './TabIconWrapper';

interface ITabIconProps {
  status: DeviationDto['status'];
  size?: 'md' | 'lg';
  isActive?: boolean;
  noBorder?: boolean;
}

export const TabIcon: React.FC<ITabIconProps> = ({ status, size, isActive, noBorder }) => {
  const iconSize = size === 'lg' ? 24 : 16;

  const icon = useMemo(() => {
    switch (status) {
      case 'UNFILLED':
        return <IconInfoCircle color='#597282' size={iconSize} />;
      case 'APPROVED_UNDONE':
        return <IconCheckCircle color='#597282' size={iconSize} />;
      case 'REJECTED_UNDONE':
        return <IconExclamationCircle color='#597282' size={iconSize} />;
      case 'REJECTED_DONE':
        return <IconExclamationCircle size={iconSize} />;
      case 'DONE':
        return <IconCheckCircle size={iconSize} />;
      default:
        return <IconInfoCircle color='#597282' size={iconSize} />;
    }
  }, [iconSize, status]);

  return (
    <TabIconWrapper status={status} isActive={isActive} noBorder={noBorder}>
      {icon}
    </TabIconWrapper>
  );
};
